<template>
  <ul v-if="isNotEmpty" class="w-full bg-white overflow-hidden rounded-xl nav-wrapper shadow">
    <navigation-item v-for="item in data" :key="item.to" :item="item" />
  </ul>
  <div v-else>
    <h3>No hay notificaciones pendientes</h3>
  </div>
</template>

<script>
import NavigationItem from '@/components/MainNavigationItem.vue'
export default {
  name: 'MainNav',
  props: {
    data: {
      type: Array,
      require: true
    }
  },
  components: {
    NavigationItem
  },
  computed: {
    isNotEmpty: function () {
      return this.data.length > 0
    }
  },
  methods: {
    isError: function (item) {
      return item.to === 'biometric-config'
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-wrapper {
  li {
    &:first-child {
      @apply rounded-t-xl;
    }
    &:last-child {
      @apply rounded-b-xl;
    }
  }
}
</style>
